export const tncConfig = [
  {
    "title": "Terms of Use",
    "content": [
      {
        "que": 'Introduction',
        "ans": [
          { value: 'These terms and conditions shall govern your use of our website.' },
          {
            value: 'By using our website, you accept these terms and conditions in full; accordingly, if you disagree with these terms and conditions or any part of these terms and conditions, you must not use our website.'
          },

          { value: 'If you register with our website, submit any material to our website or use any of our website services, we will ask you to expressly agree to these terms and conditions.' },
          { value: 'You must be at least [18] years of age to use our website; and by using our website or agreeing to these terms and conditions, you warrant and represent to us that you are at least [18] years of age.' },
          { value: 'Our website uses cookies; by using our website or agreeing to these terms and conditions, you consent to our use of cookies in accordance with the terms of our [privacy and cookies policy.' }


          // 'point': 'These terms and conditions shall govern your use of our website.',
          // "point": 'By using our website, you accept these terms and conditions in full; accordingly, if you disagree with these terms and conditions or any part of these terms and conditions, you must not use our website.',
          // "point": "If you register with our website, submit any material to our website or use any of our website services, we will ask you to expressly agree to these terms and conditions.",
          // "point": "You must be at least [18] years of age to use our website; and by using our website or agreeing to these terms and conditions, you warrant and represent to us that you are at least [18] years of age.",
          // "point": "Our website uses cookies; by using our website or agreeing to these terms and conditions, you consent to our use of cookies in accordance with the terms of our [privacy and cookies policy."
        ]
      },
      {
        que: 'Copyright notice',
        ans: [
          { value: 'Copyright (c) 2015 TRACTOR BAZAR.', },
          {
            header: 'Subject to the express provisions of these terms and conditions:',
            type: 'subPointer',
            points: [
              'we, together with our licensors, own and control all the copyright and other intellectual property rights in our website and the material on our website; and',
              'All the copyright and other intellectual property rights in our website and the material on our website are reserved.'
            ]
          }

        ]
      },
      {
        que: 'Licence to use website',
        ans: [
          {
            type: 'subPointer',
            header: 'You may:',
            points: [
              'View pages from our website in a web browser;',
              'Download pages from our website for caching in a web browser;',
              'Print pages from our website;',
              'Stream audio and video files from our website; and',
              'Use [our website services] by means of a web browser, to the other provisions of these terms and conditions.'
            ]
          },
          { value: 'Except as expressly permitted by Section 4.1 or the other provisions of these terms and conditions, you must not download any material from our website or save any such material to your computer.' },
          { value: 'You may only use our website for your own personal and business purposes, and you must not use our website for any other purposes.' },
          { value: 'Except as expressly permitted by these terms and conditions, you must not edit or otherwise modify any material on our website.' },
          {
            type: 'subPointer',
            header: 'Unless you own or control the relevant rights in the material, you must not:',
            points: [
              'Republish material from our website (including republication on another website);',
              'Sell, rent or sub-license material from our website;',
              'Show any material from our website in public;',
              'Exploit material from our website for a commercial purpose; or',
              'Redistribute material from our website.',
              'We reserve the right to restrict access to areas of our website, or indeed our whole website, at our discretion; you must not circumvent or bypass, or attempt to circumvent or bypass, any access restriction measures on our website.'
            ]
          }
        ]
      },
      {
        que: 'Acceptable use',
        ans: [
          {
            type: 'subPointer',
            header: 'You must not:',
            points: [
              'Use our website in any way or take any action that causes, or may cause, damage to the website or impairment of the performance, availability or accessibility of the website;',
              'Use our website in any way that is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity;',
              'use our website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software;',
              'Conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to our website without our express written consent;',
              'Access or otherwise interact with our website using any robot, spider or other automated means;',
              'Violate the directives set out in the robots.txt file for our website; or',
              'Use data collected from our website for any direct marketing activity (including without limitation email marketing, SMS marketing, telemarketing and direct mailing).'
            ]
          },
          {
            value: 'You must not use data collected from our website to contact individuals, companies or other persons or entities.'
          },
          { value: 'You must ensure that all the information you supply to us through our website, or in relation to our website, is [true, accurate, current, complete and non-misleading].' }
        ]
      },
      {
        que: 'Registration and accounts',
        ans: [
          { value: 'To be eligible for an individual account on our website under this Section 6, you must [be at least 18 years of age].' },
          { value: 'You may register for an account with our website by completing and submitting the account registration form on our website, and clicking on the verification link in the email that the website will send to you.' },
          { value: 'You must notify us in writing immediately if you become aware of any unauthorised use of your account.' },
          { value: 'You must not use any other person\'s account to access the website [, unless you have that person\'s express permission to do so].' },
        ]
      },
      {
        que: 'User IDs and passwords',
        ans: [
          {
            value: 'If you register for an account with our website, [we will provide you with / you will be asked to choose] a user ID and password.'
          },
          {
            value: 'Your user ID must not be liable to mislead and must comply with the content rules set out in Section 10; you must not use your account or user ID for or in connection with the impersonation of any person.'
          },
          {
            value: 'You must keep your password confidential.',
          },
          {
            value: 'You must notify us in writing immediately if you become aware of any disclosure of your password.'
          },
          {
            value: 'You are responsible for any activity on our website arising out of any failure to keep your password confidential, and may be held liable for any losses arising out of such a failure.'
          }
        ]
      },
      {
        que: 'Cancellation and suspension of account',
        ans: [
          {
            type: 'subPointer',
            header: 'We may:',
            points: [
              'Suspend your account;',
              'Cancel your account; and/or',
              'Edit your account details, At any time in our sole discretion without notice or explanation.'
            ]
          },
          {
            value: 'You may edit your account on our website.'
          }
        ]
      },
      {
        que: 'Your content: licence',
        ans: [
          { value: 'In these terms and conditions, "your content" means all works and materials (including without limitation text, graphics, images, audio material, video material, audio-visual material, scripts, software and files) that you submit to us or our website for storage or publication on, processing by, or transmission via, our website.' },
          { value: 'You grant to us a [worldwide, irrevocable, non-exclusive, royalty-free licence] to [use, reproduce, store, adapt, publish, translate and distribute your content in any existing or future media / reproduce, store and publish your content on and in relation to this website and any successor website / reproduce, store and, with your specific consent, publish your content on and in relation to this website].' },
          { value: 'You grant to us the right to sub-license the rights licensed under Section 9.2.' },
          { value: 'You grant to us the right to bring an action for infringement of the rights licensed under Section 9.2.' },
          { value: 'You hereby waive all your moral rights in your content to the maximum extent permitted by applicable law; and you warrant and represent that all other moral rights in your content have been waived to the maximum extent permitted by applicable law.' },
          { value: 'You may edit your content to the extent permitted using the editing functionality made available on our website.' },
          { value: 'Without prejudice to our other rights under these terms and conditions, if you breach any provision of these terms and conditions in any way, or if we reasonably suspect that you have breached these terms and conditions in any way, we may delete, unpublish or edit any or all of your content.' }
        ]
      },
      {
        que: 'Your content: rules',
        ans: [
          { value: 'You warrant and represent that your content will comply with these terms and conditions.' },
          { value: 'Your content must not be illegal or unlawful, must not infringe any person\'s legal rights, and must not be capable of giving rise to legal action against any person (in each case in any jurisdiction and under any applicable law).' },
          {
            header: 'Your content, and the use of your content by us in accordance with these terms and conditions, must not:',
            type: 'subPointer',
            points: [
              'Be libellous or maliciously false;',
              'Be obscene or indecent;',
              'infringe any copyright, moral right, database right, trade mark right, design right, right in passing off, or other intellectual property right;',
              'Infringe any right of confidence, right of privacy or right under data protection legislation;',
              'Constitute negligent advice or contain any negligent statement;',
              'Constitute an incitement to commit a crime, instructions for the commission of a crime or the promotion of criminal activity;',
              'Be in contempt of any court, or in breach of any court order;',
              'Be in breach of racial or religious hatred or discrimination legislation;',
              'be blasphemous;',
              'Be in breach of official secrets legislation;',
              'Be in breach of any contractual obligation owed to any person;',
              'Depict violence, in an explicit, graphic or gratuitous manner;',
              'Be pornographic, lewd, suggestive or sexually explicit;',
              'Be pornographic, lewd, suggestive or sexually explicit;',
              'consist of or contain any instructions, advice or other information which may be acted upon and could, if acted upon, cause illness, injury or death, or any other loss or damage;',
              'Constitute spam;',
              'Be offensive, deceptive, fraudulent, threatening, abusive, harassing, anti-social, menacing, hateful, discriminatory or inflammatory; or',
              'Be offensive, deceptive, fraudulent, threatening, abusive, harassing, anti-social, menacing, hateful, discriminatory or inflammatory; or'
            ]
          }
        ]
      },
      {
        que: 'Limited warranties',
        ans: [
          {
            type: 'subPointer',
            header: 'We do not warrant or represent:',
            points: [
              'The completeness or accuracy of the information published on our website;',
              'That the material on the website is up to date; or',
              'That the website or any service on the website will remain available.'
            ]
          },
          { value: 'We reserve the right to discontinue or alter any or all of our website services, and to stop publishing our website, at any time in our sole discretion without notice or explanation; and save to the extent expressly provided otherwise in these terms and conditions, you will not be entitled to any compensation or other payment upon the discontinuance or alteration of any website services, or if we stop publishing the website.' },
          { value: 'To the maximum extent permitted by applicable law and subject to Section 12.1, we exclude all representations and warranties relating to the subject matter of these terms and conditions, our website and the use of our website.' }
        ]
      },
      {
        que: 'Limitations and exclusions of liability',
        ans: [
          {
            type: 'subPointer',
            header: 'Nothing in these terms and conditions will:',
            points: [
              'Limit or exclude any liability for death or personal injury resulting from negligence;',
              'Limit or exclude any liability for fraud or fraudulent misrepresentation;',
              'Limit any liabilities in any way that is not permitted under applicable law; or',
              'Exclude any liabilities that may not be excluded under applicable law.'
            ]
          },
          {
            type: 'subPointer',
            header: 'The limitations and exclusions of liability set out in this Section 12 and elsewhere in these terms and conditions:',
            points: [
              'Are subject to Section 12.1; and',
              'Govern all liabilities arising under these terms and conditions or relating to the subject matter of these terms and conditions, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty.'
            ]
          },
          { value: 'To the extent that our website and the information and services on our website are provided free of charge, we will not be liable for any loss or damage of any nature.' },
          { value: 'We will not be liable to you in respect of any losses arising out of any event or events beyond our reasonable control.' },
          { value: 'We will not be liable to you in respect of any business losses, including (without limitation) loss of or damage to profits, income, revenue, use, production, anticipated savings, business, contracts, commercial opportunities or goodwill.' },
          { value: 'We will not be liable to you in respect of any loss or corruption of any data, database or software.' },
          { value: 'We will not be liable to you in respect of any special, indirect or consequential loss or damage.' },
          { value: 'You accept that we have an interest in limiting the personal liability of our officers and employees and, having regard to that interest, you acknowledge that we are a limited liability entity; you agree that you will not bring any claim personally against our officers or employees in respect of any losses you suffer in connection with the website or these terms and conditions (this will not, of course, limit or exclude the liability of the limited liability entity itself for the acts and omissions of our officers and employees).' }
        ]
      },
      {
        que: 'Breaches of these terms and conditions',
        ans: [
          {
            type: 'subPointer',
            header: 'Without prejudice to our other rights under these terms and conditions, if you breach these terms and conditions in any way, or if we reasonably suspect that you have breached these terms and conditions in any way, we may:',
            points: [
              'Send you one or more formal warnings;',
              'Temporarily suspend your access to our website;',
              'Permanently prohibit you from accessing our website;',
              'Block computers using your IP address from accessing our website;',
              'Contact any or all your internet service providers and request that they block your access to our website;',
              'Commence legal action against you, whether for breach of contract or otherwise; and/or',
              'Suspend or delete your account on our website.'
            ]
          },
          {
            value: 'Where we suspend or prohibit or block your access to our website or a part of our website, you must not take any action to circumvent such suspension or prohibition or blocking (including without limitation creating and/or using a different account).'
          }
        ]
      },
      {
        que: 'Variation',
        ans: [
          { value: 'We may revise these terms and conditions from time to time.' },
          { value: 'The revised terms and conditions shall apply to the use of our website from the date of publication of the revised terms and conditions on the website, and you hereby waive any right you may otherwise have to be notified of, or to consent to, revisions of these terms and conditions. / We will give you written notice of any revision of these terms and conditions, and the revised terms and conditions will apply to the use of our website from the date that we give you such notice; if you do not agree to the revised terms and conditions, you must stop using our website.' },
          { value: 'If you have given your express agreement to these terms and conditions, we will ask for your express agreement to any revision of these terms and conditions; and if you do not give your express agreement to the revised terms and conditions within such period as we may specify, we will disable or delete your account on the website, and you must stop using the website.' }
        ]
      },
      {
        que: 'Assignment',
        ans: [
          { value: 'You hereby agree that we may assign, transfer, sub-contract or otherwise deal with our rights and/or obligations under these terms and conditions.' },
          { value: 'You may not without our prior written consent assign, transfer, sub-contract or otherwise deal with any of your rights and/or obligations under these terms and conditions.' }
        ]
      },
      {
        que: 'Severability',
        ans: [
          { value: 'If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect.' },
          { value: 'If any unlawful and/or unenforceable provision of these terms and conditions would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.' }
        ]
      },
      {
        que: 'Third party rights',
        ans: [
          { value: 'These terms and conditions are for our benefit and your benefit, and these terms and conditions are not intended to benefit or be enforceable by any third party.' },
          { value: 'The exercise of the parties\' rights under these terms and conditions is not subject to the consent of any third party.' }
        ]
      },
      {
        que: 'Entire agreement',
        ans: [
          { value: 'Subject to Section 12.1, these terms and conditions, together with [our privacy and cookies policy], shall constitute the entire agreement between you and us in relation to your use of our website and shall supersede all previous agreements between you and us in relation to your use of our website.' }
        ]
      }
    ]
  }
];

